<div
  istag="menucontainer"
  [class]="phonemenu ? 'mobilemenucontainer' : 'menucontainer'"
>
  <ng-template #menucontaineritems></ng-template>
</div>

<ng-template #menucontainer></ng-template>
